import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ErrorBoundary from "components/common/ErrorBoundary";
import Routes from "routes";
import "index.css";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const location = useLocation();

  useEffect(() => {
    document.querySelector(".main_part")?.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <ErrorBoundary>
      <ToastContainer autoClose={3000} />
      <Routes />
    </ErrorBoundary>
  );
};

export default App;
